import {
    keyboard
} from './keyboard';

const userEvent = {
    keyboard
}

export default userEvent;

export type {keyboardKey} from './keyboard'
